"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function KnowledgeHero() {
  //  保留你原有的滾動偵測 Hook，維持滑順的進場動畫體驗
  const {
    ref: headerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={headerRef} className="relative h-[65vh] min-h-[450px] md:min-h-[550px] w-full overflow-hidden bg-[#f3ede5] flex items-center">
      {/* 背景圖片層 */}
      <div className="absolute inset-0 z-0">
        <img src="https://hent.services/wp-content/uploads/2026/05/Knowledge_BG_Top.webp" alt="Knowledge Base" className={cn("h-full w-full object-cover object-top transition-transform duration-[3000ms] ease-out", isVisible ? "scale-102" : "scale-100")} />
        {/*  核心修改 1：徹底移除了原本死黑的 gradient-to-r 與 gradient-to-t 遮罩！
            改用極致輕薄的 5% 微白柔光，百分之百解放圖片原本明亮暖和、陽光灑落的居家木地板採光 */}
        <div className="absolute inset-0 bg-white/5 md:bg-transparent" />
      </div>

      {/* 內容排版層 - 精準對齊圖片左側比例 */}
      <div className="container relative z-30 mx-auto px-6 md:px-12 lg:px-24">
        {/*  動態進場：依循你原本的 isVisible 邏輯，改為更加優雅溫柔的由下往上 (translate-y) 浮現 */}
        <div className={cn("max-w-3xl transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0")}>
          
          {/*  核心修改 2：麵包屑導覽 
              - 顏色同步為品牌副色 #7a6a59，縮小字級，字距拉開到 tracking-[0.25em] 營造精品感
              - 分類名稱改為大寫的 DISCOVERY
           */}
          <nav className="mb-6 flex items-center gap-1.5 text-lg md:text-xl font-sans tracking-[0.25em] text-[#7a6a59] font-medium">
            <Link to="/" className="hover:text-[#604f45] transition-colors">HOME</Link>
            <span>/</span>
            <span className="text-[#604f45] uppercase">Discovery</span>
          </nav>

          {/*  核心修改 3：大氣的主副雙行英文標題
              - 顏色更換為穩重、富有高級質感的偏深灰褐 #3d3d3d (非死黑)
              - 運用 font-sans 粗細對比 (font-bold 搭配 font-light)，百分之百還原美式裝潢雜誌封面排版
           */}
          <div className="space-y-1 md:space-y-2">
            <h1 className="font-sans text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#3d3d3d] tracking-wide leading-none uppercase select-none">
              Flooring
            </h1>
            <p className="font-sans text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-[#3d3d3d] tracking-wider leading-none uppercase select-none">
              Made for Loving
            </p>
          </div>

          {/*  核心修改 4：左下角詩意手寫感名句
              - 拋棄原本死板的大段文字，改為極具情緒張力與空間故事感的對齊落款
              - 運用 font-hk-regular 控制中文字距，並透過 pl-4 / pl-6 實作高級感向右縮排
           */}
          <div className="mt-14 md:mt-20 max-w-xl">
            <p className="font-hk-regular text-1xl md:text-2xl text-[#3d3d3d] leading-relaxed tracking-widest pl-1 select-none">
              “好的地板
              <br />
              <span className="block mt-1 pl-4 md:pl-6">
                陪伴生活慢慢變成喜歡的樣子”
              </span>
            </p>
          </div>

        </div>
      </div>
    </section>;
}